import React, { forwardRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import AngLoader from "../../component.ang_loader.jsx";

export const ElementRoot = forwardRef(({ children, zoom, loaded }, ref) => {
  return (
    <div
      className={classnames("ang_preview_container", {
        fitable: !zoom,
        loaded,
      })}
      ref={ref}
    >
      {!loaded ? <AngLoader /> : null}
      {children}
    </div>
  );
});

ElementRoot.propTypes = {
  zoom: PropTypes.bool,
  loaded: PropTypes.bool,
  children: PropTypes.node,
};

ElementRoot.defaultProps = {
  zoom: false,
  loaded: false,
};

ElementRoot.displayName = "ElementRoot";
